var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._b({class:_vm.classes,attrs:{"type":"file"},on:{"change":_vm.fileChanged}},'input',_vm.attributes,false))}
var staticRenderFns = []

export { render, staticRenderFns }